import React from 'react';
import RefLastResults from './RefLastResults';
import PokerResultBody from '../../../casinoComponents/refResultModal/PokerResultBody';

// Reference: win 1 → <span class="resulta">A</span>, 2 → <span class="resultb">B</span>, 0 → <span>T</span>
const item = (win) =>
  win === '1' ? { cls: 'resulta', text: 'A' } : win === '2' ? { cls: 'resultb', text: 'B' } : { cls: '', text: win === '0' ? 'T' : '' };

/** Last Result items + result modal for Poker 1-Day (poker), reference markup. */
const ResultPoker = ({ data = [], gameType = 'poker' }) => (
  <RefLastResults
    apiType={(gameType || 'poker').toLowerCase().trim()}
    data={data}
    item={item}
    renderBody={(t1) => <PokerResultBody t1={t1} />}
    fallbackTitle="Poker 1-Day"
  />
);

export default ResultPoker;
